import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ConnectionStatus, ErrorReason, isHTTPError } from "@evergis/api";

import { connectionChange, PublicConnectionStatus } from "ducks/sp/sp";
import { WorkspaceError } from "resources/user";
import { setAppConfig } from "ducks/appConfig";
import { api } from "evergis/api";
import { setUser } from "ducks/user";
import { UserInfo } from "evergis/core/user/UserInfo";
import { DEFAULT_MODULES } from "appConfig/defaultModules";
import { useIsShared } from "./useIsShared";
import { ModuleName } from "../../appConfig/types";

const MODULE_NAMES = Object.values(ModuleName);

export const useServerConnectionEffect = (loading: boolean, error?: Error, isLoggedSuccess?: boolean) => {
  const isShared = useIsShared();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isShared && !loading && error) {
      if (error instanceof WorkspaceError) {
        dispatch(connectionChange(PublicConnectionStatus.InvalidWorkspace));

        return;
      }

      if (isHTTPError(error) && error.reason === ErrorReason.HTTP_CLIENT) {
        api.logout();
      } else {
        dispatch(connectionChange(ConnectionStatus.Lost));
      }
    }

    if (!loading) {
      const serverModules = api.clientSettings.settings.modules.filter(({ name }) => {
        const isContain = MODULE_NAMES.includes(name as ModuleName);

        if (!isContain) {
          console.warn(`Module ${name} is not contained in list`);
        }

        return isContain;
      });

      const isEmptyModules = serverModules.length === 0;

      const settings = isEmptyModules
        ? {
            ...api.clientSettings.settings,
            modules: DEFAULT_MODULES,
          }
        : {
            ...api.clientSettings.settings,
            modules: serverModules,
          };

      dispatch(setAppConfig(settings));

      if (isLoggedSuccess) {
        dispatch(setUser(new UserInfo(api.account.user)));
      }
    }
  }, [dispatch, loading, error, isLoggedSuccess, isShared]);
};
